import { createFileRoute } from '@tanstack/react-router';
import { isPermissionParcialOrFull } from '@/features/login/util/permission';
import { validateRoute } from '@/router/util';

export const Route = createFileRoute('/a/relatorio/financeiro')({
    beforeLoad: () => {
        validateRoute({
            fintech: true,
            validatePermission: ({ upp_relatorio_financeiro }) =>
                isPermissionParcialOrFull(upp_relatorio_financeiro),
        });
    },
});
